import axios from 'axios'
import {
  RelevoUsuarioRequestModel,
  RelevoHabitacionRequestModel,
  RelevoResponseModel,
  RelevoWithListsDto,
} from '../features/guests/model'
import { ResponseObject } from '../../../models'

const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getGrupoByUsuario(id: string, huespedId?: string) {
  return axios.get<ResponseObject<RelevoResponseModel>>(`${BASEURL}/relevo/getGrupoByUsuario`, {
    params: { UsuarioId: id, HuespedId: huespedId },
  })
}

export async function postRelevoAgregarUsuario(dto: RelevoUsuarioRequestModel) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/relevo/agregarUsuario`, dto)
}

export async function postRelevoAgregarHabitacion(dto: RelevoHabitacionRequestModel) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/relevo/agregarHabitacion`, dto)
}

export async function deleteRelevoUsuario(dto: { Id: string }[]) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/relevo/removeUsuario`, dto)
}

export async function deleteRelevoHabitacion(dto: { Id: string }[]) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/relevo/removeHabitacion`, dto)
}

export async function createRelevoWithLists(dto: RelevoWithListsDto) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/relevo/createWithLists`, dto)
}

export async function updateRelevoWithLists(dto: RelevoWithListsDto) {
  return await axios.put<ResponseObject<any>>(`${BASEURL}/relevo/updateWithLists`, dto)
}
